import { useState, useEffect, useCallback } from 'react';
import {
    Wallet,
    ArrowRightLeft,
    ArrowDown,
    Copy,
    Search,
    Check,
    AlertCircle,
    X,
    ChevronLeft,
    ChevronRight,
    RefreshCw,
    Filter,
    CreditCard,
    DollarSign,
    ArrowUp,
    Clock,
    AlertTriangle,
    Eye,
    ChevronDown,
    ExternalLink,
    Loader,
    Info
} from 'lucide-react';
import { financialService } from './services/financialService';


// 🆕 ПРАВИЛЬНЫЙ ВИДЖЕТ NOWPAYMENTS С ВВОДОМ СУММЫ
const NowPaymentsDepositWidget = ({ onSuccess, balances }) => {
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [paymentUrl, setPaymentUrl] = useState('');
    // 💰 Расчет комиссии
    const [calculatedFee, setCalculatedFee] = useState(0);
    const [totalToPay, setTotalToPay] = useState(0);

    // 🧮 Автоматический расчет комиссии при изменении суммы
    useEffect(() => {
        if (amount && !isNaN(amount) && parseFloat(amount) >= 10) {
            const amountNum = parseFloat(amount);
            const feePercent = 0.5; // 0.5% комиссия NOWPayments
            const networkFee = 1.0; // ~$1 сетевая комиссия

            const fee = (amountNum * feePercent / 100) + networkFee;
            const total = amountNum + fee;

            setCalculatedFee(fee.toFixed(2));
            setTotalToPay(total.toFixed(2));
        } else {
            setCalculatedFee(0);
            setTotalToPay(0);
        }
    }, [amount]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const amountNum = parseFloat(amount);

        if (!amountNum || amountNum < 10) {
            setError('Минимальная сумма: 15 USDT');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await financialService.createDepositNowPayments({
                amount: amountNum // ✅ Отправляем ВВЕДЁННУЮ пользователем сумму
            });

            console.log('📦 Ответ от API:', response);

            if (response.success && response.data?.payLink) {
                console.log('✅ Ссылка на оплату:', response.data.payLink);

                setPaymentUrl(response.data.payLink);

                // Сохраняем информацию о платеже
                try {
                    localStorage.setItem('pendingPayment', JSON.stringify({
                        operationId: response.data.operation_id,
                        amount: amountNum,
                        currency: 'USDT',
                        paymentMethod: 'nowpayments_bep20',
                        paymentId: response.data.payment_id,
                        timestamp: Date.now()
                    }));
                } catch (e) {
                    console.error('Ошибка сохранения в localStorage:', e);
                }

                console.log('🚀 РЕДИРЕКТ НА ОПЛАТУ');

                // Уведомляем об успехе
                if (onSuccess) {
                    onSuccess();
                }

                // Редирект на страницу оплаты
                window.location.href = response.data.payLink;

            } else {
                setError(response.message || 'Ошибка создания платежа');
            }
        } catch (err) {
            console.error('Payment error:', err);
            setError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    // Быстрый выбор суммы
    const quickAmounts = [15, 25, 50, 100, 500];

    const handleQuickAmount = (quickAmount) => {
        setAmount(quickAmount.toString());
    };

    return (
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 shadow-lg border-2 border-green-200">
            {/* Заголовок */}
            <div className="flex items-center gap-3 mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-green-600 to-emerald-500 rounded-xl flex items-center justify-center shadow-md">
                    <CreditCard className="text-white" size={28} />
                </div>
                <div>
                    <h3 className="text-xl font-bold text-gray-800">
                        Пополнение через USDT BEP-20
                    </h3>
                    <p className="text-sm text-gray-600">
                        Binance Smart Chain (низкие комиссии)
                    </p>
                </div>
            </div>

            {/* Информационный блок о BEP-20 */}
            <div className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-lg p-4 mb-6 border-2 border-yellow-200">
                <div className="flex items-start gap-3">
                    <Info className="text-amber-600 flex-shrink-0 mt-1" size={20} />
                    <div className="text-sm text-gray-800">
                        <p className="font-semibold mb-2 text-amber-800">💡 Почему USDT BEP-20?</p>
                        <ul className="space-y-1.5 text-gray-700">
                            <li className="flex items-start">
                                <Check size={14} className="text-green-600 mr-2 mt-0.5 flex-shrink-0"/>
                                <span><strong>Низкие комиссии:</strong> ~$0.10-0.50 за транзакцию</span>
                            </li>
                            <li className="flex items-start">
                                <Check size={14} className="text-green-600 mr-2 mt-0.5 flex-shrink-0"/>
                                <span><strong>Быстрая обработка:</strong> 3-5 минут</span>
                            </li>
                            <li className="flex items-start">
                                <Check size={14} className="text-green-600 mr-2 mt-0.5 flex-shrink-0"/>
                                <span><strong>Сеть Binance:</strong> Надежная и популярная</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                {/* Текущий баланс */}
                <div className="bg-white rounded-lg p-4 mb-6 border border-gray-200">
                    <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Текущий баланс:</span>
                        <span className="text-lg font-bold text-green-600">
                            {balances.USDT.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDT
                        </span>
                    </div>
                </div>

                {/* Быстрый выбор суммы */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-3">
                        Быстрый выбор суммы
                    </label>
                    <div className="grid grid-cols-5 gap-2">
                        {quickAmounts.map((quickAmount) => (
                            <button
                                key={quickAmount}
                                type="button"
                                onClick={() => handleQuickAmount(quickAmount)}
                                className={`py-3 px-2 rounded-lg font-semibold text-sm transition-all
                                    ${amount === quickAmount.toString()
                                    ? 'bg-gradient-to-r from-green-600 to-emerald-500 text-white shadow-md'
                                    : 'bg-white border-2 border-gray-200 text-gray-700 hover:border-green-300'
                                }`}
                            >
                                ${quickAmount}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Ввод суммы */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Или введите свою сумму (USDT)
                    </label>
                    <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-bold text-lg">
                            $
                        </span>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            className="w-full pl-10 pr-20 py-4 border-2 border-gray-200 rounded-lg
                                     focus:border-green-500 focus:ring-2 focus:ring-green-200
                                     outline-none transition-all text-lg font-semibold"
                            placeholder="Минимум 15"
                            min="10"
                            step="0.01"
                            required
                        />
                        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">
                            USD
                        </span>
                    </div>
                    <p className="text-xs text-gray-500 mt-2 flex items-center">
                        <AlertCircle size={14} className="mr-1"/>
                        Минимальная сумма: $15 USDT
                    </p>
                </div>

                {/* 💡 Блок с деталями платежа (НОВЫЙ БЛОК) */}
                {amount && parseFloat(amount) >= 10 && (
                    <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border-2 border-blue-200">
                        <div className="flex items-start gap-3">
                            <Info className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
                            <div className="flex-1">
                                <h4 className="font-bold text-blue-900 mb-3">
                                    💰 Детали платежа
                                </h4>

                                <div className="space-y-2 text-sm">
                                    <div className="flex justify-between">
                                        <span className="text-gray-700">Вы получите на баланс:</span>
                                        <span className="font-bold text-green-600">
                                            ${parseFloat(amount).toFixed(2)}
                                        </span>
                                    </div>

                                    <div className="flex justify-between">
                                        <span className="text-gray-700">Комиссия платежной системы:</span>
                                        <span className="font-semibold text-orange-600">
                                            ${calculatedFee}
                                        </span>
                                    </div>

                                    <div className="border-t-2 border-blue-200 pt-2 mt-2">
                                        <div className="flex justify-between">
                                            <span className="text-gray-900 font-bold">Итого к оплате:</span>
                                            <span className="font-bold text-blue-600 text-lg">
                                                ${totalToPay}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <p className="text-xs text-gray-600 mt-3">
                                    ℹ️ Комиссия оплачивается вами и покрывает расходы платежной системы NOWPayments
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Ошибка */}
                {error && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                        <div className="flex items-center">
                            <AlertTriangle className="text-red-600 mr-2" size={18} />
                            <p className="text-red-600 text-sm">{error}</p>
                        </div>
                    </div>
                )}

                {/* Кнопка оплаты */}
                <button
                    type="submit"
                    disabled={loading || !amount || parseFloat(amount) < 5}
                    className="w-full py-4 bg-gradient-to-r from-green-600 to-emerald-500
                             text-white font-bold rounded-lg shadow-lg text-lg
                             hover:shadow-xl hover:from-green-700 hover:to-emerald-600
                             transform hover:scale-[1.02]
                             transition-all duration-300 disabled:opacity-50
                             disabled:cursor-not-allowed disabled:transform-none
                             flex items-center justify-center gap-2"
                >
                    {loading ? (
                        <>
                            <Loader className="animate-spin" size={22} />
                            <span>Создание платежа...</span>
                        </>
                    ) : (
                        <>
                            <CreditCard size={22} />
                            <span>Пополнить через USDT BEP-20</span>
                        </>
                    )}
                </button>
            </form>

            {/* Доступные альтернативные валюты */}
            <div className="mt-6 p-3 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-xs text-gray-600 text-center mb-2">
                    <Info size={12} className="inline mr-1"/>
                    На странице оплаты вы также сможете выбрать:
                </p>
                <div className="flex flex-wrap justify-center gap-2">
                    {['USDT TRC-20', 'Bitcoin', 'Ethereum', 'BNB', 'и другие'].map((coin) => (
                        <span
                            key={coin}
                            className="px-2 py-1 bg-white text-gray-600 text-xs rounded border border-gray-200"
                        >
                            {coin}
                        </span>
                    ))}
                </div>
            </div>

            {/* Дополнительная ссылка (если платеж уже создан) */}
            {paymentUrl && !loading && (
                <div className="mt-3 text-center">
                    <a
                        href={paymentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-green-600 hover:text-green-700 underline flex items-center justify-center gap-1"
                    >
                        <ExternalLink size={14} />
                        Открыть ссылку повторно
                    </a>
                </div>
            )}

            {/* Предупреждение */}
            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p className="text-xs text-yellow-800 flex items-start">
                    <AlertTriangle size={14} className="mr-2 mt-0.5 flex-shrink-0" />
                    <span>
                        <strong>Важно:</strong> Отправляйте только USDT BEP-20!
                        Отправка других токенов или через другие сети приведёт к потере средств.
                    </span>
                </p>
            </div>

            {/* Безопасность */}
            <div className="mt-4 text-center">
                <p className="text-xs text-gray-500 flex items-center justify-center">
                    <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 1l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V4l7-3z"/>
                    </svg>
                    Безопасная оплата через NOWPayments
                </p>
            </div>
        </div>
    );
};

const FinancePage = () => {
    // Активный таб
    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem('financeActiveTab') || 'deposit';
    });

    // Состояние для форм
    const [transferForm, setTransferForm] = useState({
        amount: '',
        recipient: '',
        description: ''
    });

    const [withdrawForm, setWithdrawForm] = useState({
        amount: '',
        wallet_address: '', // Адрес USDT кошелька
        description: ''
    });

    // Состояние для операций
    const [operations, setOperations] = useState([]);
    const [filteredOperations, setFilteredOperations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [typeFilter, setTypeFilter] = useState('all');

    // Состояние для уведомлений
    const [notification, setNotification] = useState({
        type: '',
        message: ''
    });

    // Балансы пользователя
    const [balances, setBalances] = useState({
        USDT: 0  // В интерфейсе показываем USDT, но берем из balance_usd
    });

    // Модальные окна
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [modalAction, setModalAction] = useState('');
    const [pendingOperationId, setPendingOperationId] = useState(null);
    const [confirmationCode, setConfirmationCode] = useState('');

    // Состояние для мобильных фильтров
    const [showMobileFilters, setShowMobileFilters] = useState(false);

    // Сохраняем активный таб в localStorage
    useEffect(() => {
        localStorage.setItem('financeActiveTab', activeTab);
    }, [activeTab]);

    // Загрузка данных при монтировании компонента
    useEffect(() => {
        loadBalances();
        loadOperations();
    }, []);

    // Загрузка операций при изменении фильтров или страницы
    useEffect(() => {
        loadOperations();
    }, [currentPage, searchTerm, statusFilter, typeFilter]);

    // Загрузка балансов
    const loadBalances = async () => {
        try {
            const data = await financialService.getBalances();
            if (data.success) {
                // В базе balance_usd, но показываем как USDT
                setBalances({ USDT: data.data.balances.USD });
            }
        } catch (error) {
            console.error('Error loading balances:', error);
        }
    };

    // Загрузка операций
    const loadOperations = async () => {
        setIsLoading(true);
        try {
            const data = await financialService.getOperations({
                page: currentPage,
                per_page: 10,
                search: searchTerm,
                status: statusFilter,
                type: typeFilter,
            });

            if (data.success) {
                setOperations(data.data.operations);
                setFilteredOperations(data.data.operations);
                setTotalPages(data.data.pagination.last_page);
            }
        } catch (error) {
            console.error('Error loading operations:', error);
            showNotification('error', 'Ошибка при загрузке операций');
        } finally {
            setIsLoading(false);
        }
    };

    // Показать уведомление
    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    // Обработчик успешного платежа
    const handlePaymentSuccess = () => {
        showNotification('success', 'Платёж создан! После оплаты баланс обновится автоматически.');
        setTimeout(() => {
            loadBalances();
            loadOperations();
        }, 1000);
    };

    // Обработчики изменения форм
    const handleTransferChange = useCallback((e) => {
        const { name, value } = e.target;
        setTransferForm(prev => ({ ...prev, [name]: value }));
    }, []);

    const handleWithdrawChange = useCallback((e) => {
        const { name, value } = e.target;
        setWithdrawForm(prev => ({ ...prev, [name]: value }));
    }, []);

    const handleServerError = (response) => {
        if (response.errors && typeof response.errors === 'object') {
            const errorMessages = [];
            Object.keys(response.errors).forEach(field => {
                const fieldErrors = response.errors[field];
                if (Array.isArray(fieldErrors)) {
                    errorMessages.push(...fieldErrors);
                } else {
                    errorMessages.push(fieldErrors);
                }
            });
            return errorMessages.length > 0 ? errorMessages.join('. ') : response.message;
        }
        return response.message || 'Произошла ошибка';
    };

    // Перевод
    const handleTransferSubmit = async (e) => {
        e.preventDefault();

        if (!transferForm.amount || parseFloat(transferForm.amount) <= 0) {
            showNotification('error', 'Введите корректную сумму');
            return;
        }

        if (!transferForm.recipient) {
            showNotification('error', 'Укажите получателя');
            return;
        }

        if (parseFloat(transferForm.amount) > balances.USDT) {
            showNotification('error', 'Недостаточно средств на балансе');
            return;
        }

        try {
            const data = await financialService.createTransfer(transferForm);

            if (data.success) {
                setPendingOperationId(data.data.operation_id);
                setModalAction('transfer');
                setShowConfirmationModal(true);
                showNotification('success', data.message);
            } else {
                const errorMessage = handleServerError(data);
                showNotification('error', errorMessage);
            }
        } catch (error) {
            console.error('Transfer error:', error);
            showNotification('error', 'Ошибка при создании операции перевода');
        }
    };

    // Вывод
    const handleWithdrawSubmit = async (e) => {
        e.preventDefault();

        if (!withdrawForm.amount || parseFloat(withdrawForm.amount) <= 0) {
            showNotification('error', 'Введите корректную сумму');
            return;
        }

        if (!withdrawForm.wallet_address) {
            showNotification('error', 'Укажите адрес USDT кошелька');
            return;
        }

        if (parseFloat(withdrawForm.amount) > balances.USDT) {
            showNotification('error', 'Недостаточно средств на балансе');
            return;
        }

        if (parseFloat(withdrawForm.amount) < 10) {
            showNotification('error', 'Минимальная сумма вывода: 10 USDT');
            return;
        }

        try {
            const data = await financialService.createWithdraw(withdrawForm);

            if (data.success) {
                setPendingOperationId(data.data.operation_id);
                setModalAction('withdraw');
                setShowConfirmationModal(true);
                showNotification('success', data.message);
            } else {
                const errorMessage = handleServerError(data);
                showNotification('error', errorMessage);
            }
        } catch (error) {
            console.error('Withdraw error:', error);
            showNotification('error', 'Ошибка при создании операции вывода');
        }
    };

    // Подтверждение операции
    const handleConfirmOperation = async () => {
        if (!confirmationCode) {
            showNotification('error', 'Введите код подтверждения');
            return;
        }

        try {
            const data = await financialService.confirmOperation({
                operation_id: pendingOperationId,
                confirmation_code: confirmationCode,
            });

            if (data.success) {
                showNotification('success', 'Операция успешно подтверждена');
                setShowConfirmationModal(false);
                setConfirmationCode('');

                if (modalAction === 'transfer') {
                    setTransferForm({ amount: '', recipient: '', description: '' });
                } else if (modalAction === 'withdraw') {
                    setWithdrawForm({ amount: '', wallet_address: '', description: '' });
                }

                loadBalances();
                loadOperations();
            } else {
                const errorMessage = handleServerError(data);
                showNotification('error', errorMessage);
            }
        } catch (error) {
            console.error('Confirm operation error:', error);
            showNotification('error', 'Ошибка при подтверждении операции');
        }
    };

    // Отмена операции
    const handleCancelOperation = async () => {
        try {
            const data = await financialService.cancelOperation({
                operation_id: pendingOperationId,
            });

            if (data.success) {
                showNotification('success', 'Операция отменена');
                setShowConfirmationModal(false);
                setConfirmationCode('');
                loadOperations();
            } else {
                showNotification('error', data.message);
            }
        } catch (error) {
            showNotification('error', 'Ошибка при отмене операции');
        }
    };

    // Навигация по страницам
    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Форматирование даты
    const formatDate = (dateString) => {
        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateString).toLocaleString('ru-RU', options);
    };

    // Получение класса статуса
    const getStatusClass = (status) => {
        switch (status) {
            case 'completed':
                return 'bg-green-100 text-green-800';
            case 'pending':
                return 'bg-yellow-100 text-yellow-800';
            case 'failed':
                return 'bg-red-100 text-red-800';
            case 'cancelled':
                return 'bg-gray-100 text-gray-800';
            case 'processing':
                return 'bg-blue-100 text-white-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    // Получение иконки статуса
    const getStatusIcon = (status) => {
        switch (status) {
            case 'completed':
                return <Check size={14} className="mr-1"/>;
            case 'pending':
                return <Clock size={14} className="mr-1"/>;
            case 'failed':
                return <AlertTriangle size={14} className="mr-1"/>;
            default:
                return null;
        }
    };

    // Получение текста статуса
    const getStatusText = (status) => {
        switch (status) {
            case 'completed':
                return 'Выполнено';
            case 'pending':
                return 'В обработке';
            case 'processing':
                return 'Ожидает одобрения';
            case 'failed':
                return 'Ошибка';
            case 'cancelled':
                return 'Отменено';
            default:
                return status;
        }
    };

    // Получение иконки типа операции
    const getTypeIcon = (type) => {
        switch (type) {
            case 'deposit':
                return <ArrowDown size={14} className="mr-1"/>;
            case 'withdrawal':
                return <ArrowUp size={14} className="mr-1"/>;
            case 'transfer':
                return <ArrowRightLeft size={14} className="mr-1"/>;
            default:
                return null;
        }
    };

    // Получение текста типа операции
    const getTypeText = (type) => {
        switch (type) {
            case 'deposit':
                return 'Пополнение';
            case 'withdrawal':
                return 'Вывод';
            case 'transfer':
                return 'Перевод';
            default:
                return type;
        }
    };

    // Получение класса типа операции
    const getTypeClass = (type) => {
        switch (type) {
            case 'deposit':
                return 'bg-blue-100 text-blue-800';
            case 'withdrawal':
                return 'bg-purple-100 text-purple-800';
            case 'transfer':
                return 'bg-indigo-100 text-indigo-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    return (
        <div className="p-3 md:p-6 max-w-full overflow-x-hidden">
            <h2 className="text-xl md:text-2xl font-bold text-blue-primary mb-4 md:mb-6">Финансы</h2>

            {/* Уведомления */}
            {notification.message && (
                <div className={`mb-4 p-3 rounded-lg flex items-center ${
                    notification.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                    {notification.type === 'success' ? (
                        <Check size={18} className="mr-2 flex-shrink-0"/>
                    ) : (
                        <AlertCircle size={18} className="mr-2 flex-shrink-0"/>
                    )}
                    <span className="text-sm">{notification.message}</span>
                    <button
                        type="button"
                        className="ml-auto text-gray-500 hover:text-gray-700 flex-shrink-0"
                        onClick={() => setNotification({type: '', message: ''})}
                    >
                        <X size={16}/>
                    </button>
                </div>
            )}

            {/* Счётчики баланса */}
            <div className="mb-6">
                <div
                    className="bg-white rounded-xl p-6 shadow-md transition-all hover:shadow-lg relative overflow-hidden">
                    <div
                        className="absolute right-0 top-0 w-32 h-32 bg-gradient-to-br from-green-500/10 to-blue-primary/10 rounded-bl-full"></div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-start">
                            <div
                                className="w-12 h-12 rounded-full bg-gradient-to-br from-green-500/20 to-green-600/20 flex items-center justify-center mr-4 flex-shrink-0">
                                <Wallet size={24} className="text-green-600"/>
                            </div>
                            <div className="min-w-0 flex-1">
                                <h3 className="text-sm text-gray-500 mb-1">Ваш баланс</h3>
                                <p className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-500 break-all">
                                    {balances.USDT.toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })} USDT
                                </p>
                                <p className="text-xs text-gray-400 mt-1">Tether (BEP-20)</p>
                            </div>
                        </div>
                        <div className="hidden md:flex flex-col items-end text-right">
                            <button
                                onClick={loadBalances}
                                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                                title="Обновить баланс"
                            >
                                <RefreshCw size={20} className="text-gray-600" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Табы для финансовых операций */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden mb-6">
                <div className="flex border-b overflow-x-auto">
                    <button
                        type="button"
                        className={`flex-shrink-0 py-3 px-3 md:px-4 text-center font-medium transition-colors relative text-sm ${
                            activeTab === 'deposit' ? 'text-blue-primary' : 'text-gray-500 hover:text-blue-primary/70'
                        }`}
                        onClick={() => setActiveTab('deposit')}
                    >
                        <div className="flex items-center justify-center">
                            <ArrowDown size={16} className="mr-1 md:mr-2"/>
                            <span className="whitespace-nowrap">Пополнение</span>
                        </div>
                        {activeTab === 'deposit' && (
                            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-primary"></span>
                        )}
                    </button>

                    <button
                        type="button"
                        className={`flex-shrink-0 py-3 px-3 md:px-4 text-center font-medium transition-colors relative text-sm ${
                            activeTab === 'transfer' ? 'text-blue-primary' : 'text-gray-500 hover:text-blue-primary/70'
                        }`}
                        onClick={() => setActiveTab('transfer')}
                    >
                        <div className="flex items-center justify-center">
                            <ArrowRightLeft size={16} className="mr-1 md:mr-2"/>
                            <span className="whitespace-nowrap">Перевод</span>
                        </div>
                        {activeTab === 'transfer' && (
                            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-primary"></span>
                        )}
                    </button>

                    <button
                        type="button"
                        className={`flex-shrink-0 py-3 px-3 md:px-4 text-center font-medium transition-colors relative text-sm ${
                            activeTab === 'withdraw' ? 'text-blue-primary' : 'text-gray-500 hover:text-blue-primary/70'
                        }`}
                        onClick={() => setActiveTab('withdraw')}
                    >
                        <div className="flex items-center justify-center">
                            <ArrowUp size={16} className="mr-1 md:mr-2"/>
                            <span className="whitespace-nowrap">Вывод</span>
                        </div>
                        {activeTab === 'withdraw' && (
                            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-primary"></span>
                        )}
                    </button>
                </div>

                <div className="p-4 md:p-6">
                    {/* 🆕 ВИДЖЕТ NOWPAYMENTS для пополнения */}
                    {activeTab === 'deposit' && (
                        <NowPaymentsDepositWidget
                            onSuccess={handlePaymentSuccess}
                            balances={balances}
                        />
                    )}

                    {/* Форма перевода */}
                    {activeTab === 'transfer' && (
                        <div>
                            <p className="text-sm text-gray-600 mb-4">
                                Переводите USDT другим пользователям платформы. Комиссия за перевод отсутствует.
                            </p>

                            <form onSubmit={handleTransferSubmit}>
                                <div className="space-y-6">
                                    {/* Получатель */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Логин получателя
                                        </label>
                                        <input
                                            type="text"
                                            name="recipient"
                                            value={transferForm.recipient}
                                            onChange={handleTransferChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500/50 text-base"
                                            placeholder="Введите логин получателя"
                                            required
                                        />
                                    </div>

                                    {/* Сумма перевода */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Сумма перевода
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="number"
                                                name="amount"
                                                value={transferForm.amount}
                                                onChange={handleTransferChange}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500/50 text-base"
                                                placeholder="Введите сумму"
                                                min="0.01"
                                                step="0.01"
                                                max={balances.USDT}
                                                required
                                            />
                                            <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 font-medium">
                            USDT
                        </span>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-2">
                                            Доступно: {balances.USDT.toLocaleString('en-US', { minimumFractionDigits: 2 })} USDT
                                        </p>
                                    </div>

                                    {/* Комментарий */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Комментарий (необязательно)
                                        </label>
                                        <input
                                            type="text"
                                            name="description"
                                            value={transferForm.description}
                                            onChange={handleTransferChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500/50 text-base"
                                            placeholder="Комментарий к переводу"
                                        />
                                    </div>

                                    {/* Информация */}
                                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                        <div className="flex items-start">
                                            <AlertCircle size={16} className="text-blue-600 mr-2 mt-0.5 flex-shrink-0"/>
                                            <div className="text-sm text-blue-800">
                                                <p>Перевод требует подтверждения кодом из Email.</p>
                                                <p className="mt-1">Комиссия за перевод: <strong>0%</strong></p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Кнопка отправки */}
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="w-full bg-gradient-to-r from-green-600 to-green-500 text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                    >
                                        {isLoading ? (
                                            <>
                                                <RefreshCw size={18} className="mr-2 animate-spin"/>
                                                <span>Обработка...</span>
                                            </>
                                        ) : (
                                            <>
                                                <ArrowRightLeft size={18} className="mr-2"/>
                                                <span>Перевести USDT</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Форма вывода */}
                    {activeTab === 'withdraw' && (
                        <div>
                            <p className="text-sm text-gray-600 mb-4">
                                Вывод USDT на ваш криптокошелек (BEP-20). Обработка заявок до 24 часов.
                            </p>

                            <form onSubmit={handleWithdrawSubmit}>
                                <div className="space-y-6">
                                    {/* Адрес кошелька */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Адрес USDT кошелька (BEP-20)
                                        </label>
                                        <input
                                            type="text"
                                            name="wallet_address"
                                            value={withdrawForm.wallet_address}
                                            onChange={handleWithdrawChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500/50 text-base font-mono text-sm"
                                            placeholder="0x..."
                                            required
                                        />
                                        <p className="text-xs text-red-500 mt-2 flex items-center">
                                            <AlertTriangle size={14} className="mr-1"/>
                                            Проверьте адрес! Средства, отправленные на неверный адрес, не подлежат возврату.
                                        </p>
                                    </div>

                                    {/* Сумма вывода */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Сумма вывода
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="number"
                                                name="amount"
                                                value={withdrawForm.amount}
                                                onChange={handleWithdrawChange}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500/50 text-base"
                                                placeholder="Введите сумму"
                                                min="10"
                                                step="0.01"
                                                max={balances.USDT}
                                                required
                                            />
                                            <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 font-medium">
                            USDT
                        </span>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-2">
                                            Доступно: {balances.USDT.toLocaleString('en-US', { minimumFractionDigits: 2 })} USDT | Минимум: 10 USDT
                                        </p>
                                    </div>

                                    {/* Комментарий */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Комментарий (необязательно)
                                        </label>
                                        <input
                                            type="text"
                                            name="description"
                                            value={withdrawForm.description}
                                            onChange={handleWithdrawChange}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500/50 text-base"
                                            placeholder="Комментарий к выводу"
                                        />
                                    </div>

                                    {/* Информация */}
                                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                                        <div className="flex items-start">
                                            <AlertCircle size={16} className="text-amber-600 mr-2 mt-0.5 flex-shrink-0"/>
                                            <div className="text-sm text-amber-800">
                                                <p className="font-medium mb-1">Условия вывода:</p>
                                                <ul className="list-disc list-inside space-y-1">
                                                    <li>Минимальная сумма: 15 USDT</li>
                                                    <li>Комиссия сети BEP-20: ~0.5-1 USDT</li>
                                                    <li>Время обработки: до 24 часов</li>
                                                    <li>Требуется подтверждение Email</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Кнопка отправки */}
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="w-full bg-gradient-to-r from-green-600 to-green-500 text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                    >
                                        {isLoading ? (
                                            <>
                                                <RefreshCw size={18} className="mr-2 animate-spin"/>
                                                <span>Обработка...</span>
                                            </>
                                        ) : (
                                            <>
                                                <ArrowUp size={18} className="mr-2"/>
                                                <span>Вывести USDT</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>

            {/* История операций */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="px-4 py-3 border-b">
                    <div
                        className="flex flex-col space-y-3 md:flex-row md:justify-between md:items-center md:space-y-0">
                        <h3 className="text-base font-semibold text-gray-700">История операций</h3>

                        <div className="flex flex-col space-y-3 md:flex-row md:items-center md:space-y-0 md:space-x-3">
                            {/* Поиск */}
                            <div className="relative flex-1 md:flex-initial md:w-64">
                                <input
                                    type="text"
                                    placeholder="Поиск операций..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                />
                                <Search size={16}
                                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"/>
                            </div>

                            {/* Мобильная кнопка фильтров */}
                            <div className="md:hidden">
                                <button
                                    onClick={() => setShowMobileFilters(!showMobileFilters)}
                                    className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 transition-colors"
                                >
                                    <Filter size={16} className="mr-2"/>
                                    <span>Фильтры</span>
                                    <ChevronDown size={16}
                                                 className={`ml-2 transform transition-transform ${showMobileFilters ? 'rotate-180' : ''}`}/>
                                </button>
                            </div>

                            {/* Десктопные фильтры */}
                            <div className="hidden md:flex md:space-x-2">
                                <select
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                >
                                    <option value="all">Все статусы</option>
                                    <option value="completed">Выполнено</option>
                                    <option value="pending">В обработке</option>
                                    <option value="failed">Ошибка</option>
                                    <option value="cancelled">Отменено</option>
                                </select>

                                <select
                                    value={typeFilter}
                                    onChange={(e) => setTypeFilter(e.target.value)}
                                    className="p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                >
                                    <option value="all">Все типы</option>
                                    <option value="deposit">Пополнение</option>
                                    <option value="withdrawal">Вывод</option>
                                    <option value="transfer">Перевод</option>
                                </select>

                                <button
                                    onClick={loadOperations}
                                    className="p-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 transition-colors"
                                    disabled={isLoading}
                                >
                                    <RefreshCw size={16} className={`${isLoading ? 'animate-spin' : ''}`}/>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Мобильные фильтры */}
                    {showMobileFilters && (
                        <div className="mt-3 pt-3 border-t md:hidden">
                            <div className="grid grid-cols-2 gap-3">
                                <select
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                >
                                    <option value="all">Все статусы</option>
                                    <option value="completed">Выполнено</option>
                                    <option value="pending">В обработке</option>
                                    <option value="failed">Ошибка</option>
                                    <option value="cancelled">Отменено</option>
                                </select>

                                <select
                                    value={typeFilter}
                                    onChange={(e) => setTypeFilter(e.target.value)}
                                    className="p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-primary/50"
                                >
                                    <option value="all">Все типы</option>
                                    <option value="deposit">Пополнение</option>
                                    <option value="withdrawal">Вывод</option>
                                    <option value="transfer">Перевод</option>
                                </select>
                            </div>

                            <div className="mt-3">
                                <button
                                    onClick={loadOperations}
                                    className="w-full flex items-center justify-center p-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 transition-colors"
                                    disabled={isLoading}
                                >
                                    <RefreshCw size={16} className={`mr-2 ${isLoading ? 'animate-spin' : ''}`}/>
                                    <span>Обновить</span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* Мобильная версия операций (карточки) */}
                <div className="md:hidden">
                    {filteredOperations.length > 0 ? (
                        <div className="divide-y divide-gray-200">
                            {filteredOperations.map(operation => (
                                <div key={operation.id} className="p-4">
                                    <div className="flex items-start justify-between mb-2">
                                        <div className="flex items-center">
                                            <span
                                                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mr-2 ${getTypeClass(operation.type)}`}>
                                                {getTypeIcon(operation.type)}
                                                {getTypeText(operation.type)}
                                            </span>
                                            <span
                                                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusClass(operation.status)}`}>
                                                {getStatusIcon(operation.status)}
                                                {getStatusText(operation.status)}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mb-2">
                                        <p className="text-sm font-medium text-gray-900 mb-1">
                                            {operation.description}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                            ID: {operation.transaction_id || operation.id}
                                        </p>
                                    </div>

                                    <div className="flex items-center justify-between">
                                        <div className={`text-sm font-medium ${
                                            operation.type === 'deposit' ? 'text-green-600' :
                                                operation.type === 'withdrawal' ? 'text-red-600' :
                                                    'text-blue-600'
                                        }`}>
                                            {operation.balance_change ||
                                                `${operation.type === 'deposit' ? '+' : operation.type === 'withdrawal' ? '-' : ''}${parseFloat(operation.amount).toLocaleString('ru-RU')} ${operation.currency === 'RUB' ? '₽' : '$'}`
                                            }
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            {formatDate(operation.created_at)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="p-8 text-center text-gray-500">
                            {isLoading ? (
                                <div className="flex justify-center items-center">
                                    <RefreshCw size={24} className="animate-spin mr-2"/>
                                    <span>Загрузка...</span>
                                </div>
                            ) : (
                                <>
                                    <div className="flex justify-center mb-3">
                                        <div
                                            className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-400">
                                            <Wallet size={24}/>
                                        </div>
                                    </div>
                                    <p>История операций пуста.</p>
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* Десктопная версия операций (таблица) */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                        <tr>
                            <th scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Операция
                            </th>
                            <th scope="col"
                                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Тип
                            </th>
                            <th scope="col"
                                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Статус
                            </th>
                            <th scope="col"
                                className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Сумма
                            </th>
                            <th scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Дата
                            </th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {filteredOperations.length > 0 ? (
                            filteredOperations.map(operation => (
                                <tr key={operation.id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div>
                                            <div
                                                className="text-sm font-medium text-gray-900">{operation.description}</div>
                                            <div
                                                className="text-xs text-gray-500">{operation.transaction_id || operation.id}</div>
                                        </div>
                                    </td>
                                    <td className="px-3 py-4 whitespace-nowrap">
                                        <span
                                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getTypeClass(operation.type)}`}>
                                            {getTypeIcon(operation.type)}
                                            {getTypeText(operation.type)}
                                        </span>
                                    </td>
                                    <td className="px-3 py-4 whitespace-nowrap">
                                        <span
                                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusClass(operation.status)}`}>
                                            {getStatusIcon(operation.status)}
                                            {getStatusText(operation.status)}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-right">
                                        <div className={`text-sm font-medium ${
                                            operation.type === 'deposit' ? 'text-green-600' :
                                                operation.type === 'withdrawal' ? 'text-red-600' :
                                                    'text-blue-600'
                                        }`}>
                                            {operation.balance_change ||
                                                `${operation.type === 'deposit' ? '+' : operation.type === 'withdrawal' ? '-' : ''}${parseFloat(operation.amount).toLocaleString('ru-RU')} ${operation.currency === 'RUB' ? '₽' : '$'}`
                                            }
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {formatDate(operation.created_at)}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="px-6 py-10 text-center text-gray-500">
                                    {isLoading ? (
                                        <div className="flex justify-center items-center">
                                            <RefreshCw size={24} className="animate-spin mr-2"/>
                                            <span>Загрузка...</span>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="flex justify-center mb-3">
                                                <div
                                                    className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-400">
                                                    <Wallet size={24}/>
                                                </div>
                                            </div>
                                            <p>История операций пуста.</p>
                                        </>
                                    )}
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                {/* Пагинация */}
                {filteredOperations.length > 0 && totalPages > 1 && (
                    <div className="border-t border-gray-200 px-4 py-3">
                        {/* Мобильная пагинация */}
                        <div className="flex justify-between items-center md:hidden">
                            <button
                                type="button"
                                onClick={prevPage}
                                disabled={currentPage === 1}
                                className={`flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                                    currentPage === 1 ? 'text-gray-300 bg-gray-50' : 'text-gray-700 bg-white hover:bg-gray-50'
                                }`}
                            >
                                <ChevronLeft size={16} className="mr-1"/>
                                Назад
                            </button>

                            <span className="text-sm text-gray-700">
                                {currentPage} / {totalPages}
                            </span>

                            <button
                                type="button"
                                onClick={nextPage}
                                disabled={currentPage === totalPages}
                                className={`flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                                    currentPage === totalPages ? 'text-gray-300 bg-gray-50' : 'text-gray-700 bg-white hover:bg-gray-50'
                                }`}
                            >
                                Вперед
                                <ChevronRight size={16} className="ml-1"/>
                            </button>
                        </div>

                        {/* Десктопная пагинация */}
                        <div className="hidden md:flex md:items-center md:justify-between">
                            <div>
                                <p className="text-sm text-gray-700">
                                    Страница <span className="font-medium">{currentPage}</span> из <span
                                    className="font-medium">{totalPages}</span>
                                </p>
                            </div>
                            <div>
                                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                                     aria-label="Pagination">
                                    <button
                                        type="button"
                                        onClick={prevPage}
                                        disabled={currentPage === 1}
                                        className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${
                                            currentPage === 1 ? 'text-gray-300' : 'text-gray-500 hover:bg-gray-50'
                                        }`}
                                    >
                                        <span className="sr-only">Предыдущая</span>
                                        <ChevronLeft size={16}/>
                                    </button>

                                    <button
                                        type="button"
                                        onClick={nextPage}
                                        disabled={currentPage === totalPages}
                                        className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${
                                            currentPage === totalPages ? 'text-gray-300' : 'text-gray-500 hover:bg-gray-50'
                                        }`}
                                    >
                                        <span className="sr-only">Следующая</span>
                                        <ChevronRight size={16}/>
                                    </button>
                                </nav>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Модальное окно подтверждения */}
            {showConfirmationModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 max-h-screen overflow-y-auto">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-800">
                                {modalAction === 'transfer' ? 'Подтверждение перевода' : 'Подтверждение вывода'}
                            </h3>
                            <button
                                type="button"
                                className="text-gray-400 hover:text-gray-600"
                                onClick={() => setShowConfirmationModal(false)}
                            >
                                <X size={20}/>
                            </button>
                        </div>

                        <div className="bg-gray-50 p-4 rounded-lg mb-4">
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm text-gray-600">Операция:</span>
                                <span className="text-sm font-medium">
                                    {modalAction === 'transfer' ? 'Перевод средств' : 'Вывод средств'}
                                </span>
                            </div>

                            {modalAction === 'transfer' && (
                                <div className="flex justify-between items-center mb-2">
                                    <span className="text-sm text-gray-600">Получатель:</span>
                                    <span className="text-sm font-medium break-all">{transferForm.recipient}</span>
                                </div>
                            )}

                            {modalAction === 'withdraw' && (
                                <div className="flex justify-between items-center mb-2">
                                    <span className="text-sm text-gray-600">Кошелек:</span>
                                    <span className="text-sm font-medium">
                                        {withdrawForm.wallet === 'payeer' ? 'Payeer' : 'FK Wallet'}
                                    </span>
                                </div>
                            )}

                            <div className="flex justify-between items-center mb-2">
                                <span className="text-sm text-gray-600">Сумма:</span>
                                <span className="text-sm font-medium">
                                    {modalAction === 'transfer'
                                        ? `${transferForm.amount} ${transferForm.currency === 'RUB' ? '₽' : '$'}`
                                        : `${withdrawForm.amount} ${withdrawForm.currency === 'RUB' ? '₽' : '$'}`
                                    }
                                </span>
                            </div>

                            {modalAction === 'withdraw' && (
                                <div className="flex justify-between items-center">
                                    <span className="text-sm text-gray-600">Комиссия (1%):</span>
                                    <span className="text-sm font-medium">
                                        {(parseFloat(withdrawForm.amount || 0) * 0.01).toFixed(2)} {withdrawForm.currency === 'RUB' ? '₽' : '$'}
                                    </span>
                                </div>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Код подтверждения из Telegram
                            </label>
                            <input
                                type="text"
                                value={confirmationCode}
                                onChange={(e) => setConfirmationCode(e.target.value)}
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary/50 text-base"
                                placeholder="Введите код из Telegram"
                                maxLength="6"
                            />
                            <p className="text-xs text-gray-500 mt-1">
                                Код отправлен в ваш Telegram. Если вы не получили код, проверьте настройки уведомлений.
                            </p>
                        </div>

                        <div
                            className="flex flex-col-reverse sm:flex-row sm:justify-end space-y-3 space-y-reverse sm:space-y-0 sm:space-x-3">
                            <button
                                type="button"
                                className="w-full sm:w-auto px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                onClick={handleCancelOperation}
                            >
                                Отменить
                            </button>
                            <button
                                type="button"
                                onClick={handleConfirmOperation}
                                className={`w-full sm:w-auto px-4 py-3 rounded-lg text-white transition-colors ${
                                    confirmationCode.length >= 4
                                        ? 'bg-blue-primary hover:bg-blue-primary/90'
                                        : 'bg-gray-300 cursor-not-allowed'
                                }`}
                                disabled={confirmationCode.length < 4}
                            >
                                Подтвердить
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FinancePage;
